<div class="severity" [pTooltip]="'Severity: ' + severityName" tooltipPosition="top">
  @if (formFactor === 'stripe') {
    <div class="severity-icon {{severity}}" [ngClass]="{'modifiable': allowModification}" (click)="toggleMenu($event);">
      <fa-icon [icon]="icon" size="sm"></fa-icon>
    </div>
  } @else {
    <div class="pill {{severity}}"[ngClass]="{'modifiable': allowModification}" (click)="toggleMenu($event);">
      <fa-icon [icon]="icon" size="sm"></fa-icon>
      {{severityName}}
    </div>
  }
  <!-- styleclass not applied. primeng bug? -->
  <p-menu #menu styleClass="wm-m-severity-menu" [popup]="true" appendTo="body" [model]="menuItems">
    <ng-template pTemplate="item" let-opt>
      <div class="wm-m-severity-menu-item">
        <fa-icon class="wm-m-severity {{opt.value}}-color" [icon]="opt.faIcon" style="margin-right: 0.5rem"></fa-icon>
        <span>{{ opt.label }}</span>
      </div>
    </ng-template>
  </p-menu>
</div>
